<template>
  <div
    class="d-flex justify-content-around fs-24 mt-4"
    style="width: 80%; font-weight: 600"
  >
    <div class="position-relative">
      <img
        class="position-absolute"
        style="width: 4.75rem; height: 4.75rem; top: 0rem; left: -4rem"
        src="../../assets/images/dashboard/businessOpportunity.png"
        alt=""
      /><a
        href="javascript:void(0)"
        :class="['c-link', this.show4Channels ? 'active' : '']"
        @click="this.show4Channels = true"
        >4 Channels</a
      >
      vs
      <a
        href="javascript:void(0)"
        :class="['c-link', this.show4Channels ? '' : 'active']"
        @click="this.show4Channels = false"
        >Standard</a
      >
    </div>
    <div class="position-relative">
      <img
        class="position-absolute"
        style="width: 4.75rem; height: 4.75rem; top: 0rem; left: -4rem"
        src="../../assets/images/dashboard/businessOpportunity.png"
        alt=""
      />Business Opportunity
    </div>
    <div class="position-relative">
      <img
        class="position-absolute"
        style="width: 4.75rem; height: 4.75rem; top: 0rem; left: -4rem"
        src="../../assets/images/dashboard/businessOpportunity.png"
        alt=""
      />Booking
    </div>
  </div>
  <div class="ms-5 mb-1" style="height: 90vh; width: 95%">
    <div id="sankeyEchart" class="w-100 h-100"></div>
  </div>
  <!-- <div class="ms-5 mb-1" style="height: 90vh; width: 95%">
    <div id="sankeyEchart1" class="w-100 h-100"></div>
  </div> -->
  <div
    class="w-100 d-flex justify-content-around align-content-center align-items-center mb-5"
    style="height: 36vh"
  >
    <div
      id="pieChart1"
      class="h-100"
      style="width: 30%"
      v-show="show4Channels"
    ></div>
    <div
      id="pieChart2"
      class="h-100"
      style="width: 30%"
      v-show="show4Channels"
    ></div>
    <div
      id="pieChart3"
      class="h-100"
      style="width: 30%"
      v-show="!show4Channels"
    ></div>
    <div id="pieChart4" class="h-100" style="width: 30%"></div>
  </div>
  <div class="w-100 mb-5" style="height: 50vh">
    <div id="barChart" class="w-100 h-100"></div>
  </div>
  <div class="w-100 d-flex mt-4" style="height: 80vh; padding-bottom: 5vh">
    <div id="crosswiseBarChart" class="h-100 ms-5" style="width: 30%"></div>
    <div id="chinaChart" class="h-100" style="width: 68%"></div>
  </div>
</template>
<script>
import moment from "moment";
import { API_SVC_HOST } from "@/config/common";
import _ from "lodash";

import {
  sankeyEcharts,
  // sankeyEcharts1,
  barCharts,
  pieCharts1,
  pieCharts2,
  pieCharts3,
  pieCharts4,
  crosswiseBarCharts,
  chinaCharts,
} from "@/utils/businessOpportunityDashboard.js";
import { getChannels, getRanking, getSiteRanking } from "@/service/index";
export default {
  data() {
    return {
      overviewSiteData: {},
      timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      pathType: "business-opportunity-dashboard",
      total_am_booking: 0,
      predicted_am_booking: 0,
      predicted_rate: 0,
      show4Channels: true,
      sankeyEchartData: null,
    };
  },
  created() {
    this.$nextTick(() => {
      let ele = document.getElementById("fullBox");
      if (ele) {
        ele.style.overflow = "overlay";
        ele.style.overflowX = "hidden";
      }
    });
  },
  beforeUnmount() {
    let ele = document.getElementById("fullBox");
    if (ele) {
      ele.style.overflow = "hidden";
      ele.style.overflowX = "hidden";
    }
  },
  methods: {
    setChannelsChart() {
      getChannels().then((res) => {
        if (res && res.payload) {
          this.sankeyEchartData = res.payload;
          sankeyEcharts({
            chartDom: document.getElementById("sankeyEchart"),
            dataList: res.payload,
            mode: this.show4Channels ? "1" : "2",
          });
          // sankeyEcharts1({
          //   chartDom: document.getElementById("sankeyEchart1"),
          //   dataList: res.payload,
          //   mode: this.show4Channels ? "1" : "2",
          // });
          this.total_am_booking = parseInt(
            (res.payload.level_4.booking + res.payload.level_4.unplanned) / 1000
          );
          this.predicted_am_booking = parseInt(
            res.payload.level_1.package.value / 1000
          );
          this.predicted_rate = parseInt(
            ((this.predicted_am_booking - this.total_am_booking) /
              this.total_am_booking) *
              100
          );
        }
      });
    },
    setRanking() {
      getRanking().then((res) => {
        if (res && res.payload) {
          crosswiseBarCharts({
            chartDom: document.getElementById("crosswiseBarChart"),
            dataList: res.payload,
          });
        }
      });
    },
    logout() {
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true");
      setTimeout(() => {
        localStorage.clear();
      }, 2000);
    },
    getOverviewSite() {
      getSiteRanking().then((res) => {
        console.log(res);
        if (res && res.payload) {
          this.overviewSiteData = res.payload;
          chinaCharts({
            chartDom: document.getElementById("chinaChart"),
            dataList: res.payload,
            name: "china",
          });
        }
      });
    },
    skipPage(path) {
      this.pathType = path;
      this.$router.push("/" + path);
    },
    moment,
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;

      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("business")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      // this.$i18n.locale = lang;
      window.location.reload();
    },
  },
  computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
    predicted_rate_symbol() {
      return this.predicted_rate >= 0 ? "+" : "";
    },
  },
  mounted() {
    this.setChannelsChart();
    this.setRanking();
    barCharts({
      chartDom: document.getElementById("barChart"),
    });
    pieCharts1({
      chartDom: document.getElementById("pieChart1"),
    });
    pieCharts2({
      chartDom: document.getElementById("pieChart2"),
      name1: this.$t("overview_static['现场无此设备']"),
      name2: this.$t("overview_static['预测偏差']"),
      name3: this.$t("overview_static['竞争对手']"),
      name4: this.$t("overview_static['供应商直供']"),
      name5: this.$t("overview_static['找第三方']"),
      name6: this.$t("overview_static['客户自行维保']"),
    });
    pieCharts3({
      chartDom: document.getElementById("pieChart3"),
    });
    pieCharts4({
      chartDom: document.getElementById("pieChart4"),
    });
    this.getOverviewSite();
  },
  watch: {
    show4Channels: {
      handler(val) {
        if (this.sankeyEchartData) {
          sankeyEcharts({
            chartDom: document.getElementById("sankeyEchart"),
            dataList: this.sankeyEchartData,
            mode: val ? "1" : "2",
          });
          // sankeyEcharts1({
          //   chartDom: document.getElementById("sankeyEchart1"),
          //   dataList: this.sankeyEchartData,
          //   mode: val ? "1" : "2",
          // });
        }
        if (val) {
          pieCharts1({
            chartDom: document.getElementById("pieChart1"),
          });
          pieCharts2({
            chartDom: document.getElementById("pieChart2"),
            name1: this.$t("overview_static['现场无此设备']"),
            name2: this.$t("overview_static['预测偏差']"),
            name3: this.$t("overview_static['竞争对手']"),
            name4: this.$t("overview_static['供应商直供']"),
            name5: this.$t("overview_static['找第三方']"),
            name6: this.$t("overview_static['客户自行维保']"),
          });
        } else {
          pieCharts3({
            chartDom: document.getElementById("pieChart3"),
          });
        }
      },
    },
  },
};
</script>

<style scoped>
#business::-webkit-scrollbar {
  display: none;
}

.border_top {
  border-top: 1px solid;
  border-image: linear-gradient(
      90deg,
      #00000000 5%,
      #3342ff 25%,
      #37f4f4 50%,
      #3342ff 75%,
      #00000000 95%
    )
    2 2 2 2;
  border-radius: 30px;
}

.clickActive {
  border-radius: 23.397px;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.3) 100%
    ),
    rgba(111, 111, 111, 0.1);
  backdrop-filter: blur(5.849282264709473px);
}

.menuActive {
  border-radius: 10px;
  background: linear-gradient(
      180deg,
      rgba(254, 200, 241, 0.9) 0%,
      rgba(237, 146, 215, 0) 40.39%
    ),
    radial-gradient(
      96.63% 140.33% at 76.68% 66.67%,
      rgba(96, 46, 166, 0) 0%,
      rgba(201, 119, 214, 0.5) 100%
    );
  background-blend-mode: overlay, normal;
  /* Sign Up button */
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1),
    0px 0px 5px 0px #fface4 inset, 0px -1px 8px 0px #9375b6 inset;
}

.c-link {
  color: #fff !important;
  text-decoration: none !important;
}
.c-link:hover {
  color: #fff !important;
  text-decoration: underline !important;
}

.c-link:visited {
  color: #fff !important;
  text-decoration: none !important;
}
:deep(.c-link.active) {
  color: #fff !important;
  text-decoration: underline !important;
}
</style>
